module.exports = __webpack_public_path__ + "img/logo_neocom.499f7727.svg";